import { useState } from "react"

const useGallery = () => {
    const [data, _] = useState([
        {
            "link": "https://youtu.be/eCm7gt-LfbY?si=VU4wOMCpb5uN584F",
            "type": "ytb"
        },
        {
            "link": "https://youtu.be/L02f_rPytJo?si=L2tQXI7JJ-qJQAqK",
            "type": "ytb"
        },
        {
            "link": "https://youtu.be/SFaEDmqLoY8?si=F5-139rIxr4DrD8g",
            "type": "ytb"
        },
    ])
    return { data }
}
export default useGallery